import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken } from "@/lib/auth";

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  if (!getToken()) {
    return <Navigate to="/praticien" replace state={{ from: location.pathname }} />;
  }
  return children;
}
